import { useEffect } from 'react'
import { productName } from '../lib/config'
import { useLogOpen, usePeopleMe, usePreview } from './useTeam'

// Sits at the top of every page on an instance with the People contract:
// while an admin is seeing the app as someone else, who and a way back; and
// one quiet "opened" row per person, tab and hour for the People tab.
// `product` and `what` name another product's words (Nateva Intelligence); unset keeps the Command Centre text.
export function PeopleBar({ surfaceId, product, what }: { surfaceId?: string; product?: string; what?: string }) {
  const me = usePeopleMe().data
  const { stop } = usePreview()
  const logOpen = useLogOpen()

  useEffect(() => {
    if (surfaceId && me && !me.viewing_as) logOpen(surfaceId)
  }, [surfaceId, me, logOpen])

  if (!me?.viewing_as) return null
  const who = me.viewing_as_name ? `${me.viewing_as_name} (${me.viewing_as})` : me.viewing_as
  return (
    <div role="status" className="flex shrink-0 flex-wrap items-center justify-between gap-2 bg-accent px-4 py-2 text-sm text-white">
      <span>
        You are seeing {product ?? (__FRONT_DOOR__ ? productName : 'the Command Centre')} as <strong>{who}</strong>: {what ?? 'their tabs, their mail and their limits.'}
      </span>
      <button
        type="button"
        disabled={stop.isPending}
        onClick={() => stop.mutate()}
        className="rounded-lg bg-white px-3 py-1 text-sm font-semibold text-accent disabled:opacity-60"
      >
        {stop.isPending ? 'Stopping…' : 'Stop seeing it as them'}
      </button>
    </div>
  )
}
